import { useEffect, useRef, useState } from "react";
import { getImagePath } from "../getImagePath";

import { read, utils } from "xlsx/dist/xlsx.full.min.js"; // Use pre-transpiled UMD bundle directly because current webpack configuration does not support ES module.
import { topicKeyExcelFileNameMapping } from "../data";

export const getExcelPath = (topicKey) =>
	process.env.PUBLIC_URL + getImagePath(`/chart-data/${topicKey}.xlsx`);

const processExcelData = (workbook) => {
	try {
		const worksheet = workbook.Sheets[workbook.SheetNames[0]];
		const rawJSONData = utils.sheet_to_json(worksheet, { header: 1 });
		const cleanedUpData = rawJSONData.filter((row) => row.length > 0);

		// Remove footnote and source information
		const footnoteIndex = cleanedUpData.findIndex(
			(row) => typeof row[0] === "string" && row[0].startsWith("資料來源："),
		);
		cleanedUpData.splice(footnoteIndex, cleanedUpData.length - footnoteIndex);

		// Remove Title row e.g. "1_1避難知識的來源?"
		const maxCols = cleanedUpData.reduce(
			(max, row) => Math.max(max, row.length),
			0,
		);

		const filledUpData = cleanedUpData.map((row) => {
			for (let i = 0; i < maxCols; i++) {
				if (!row[i]) {
					row[i] = null;
				}
			}
			return row;
		});

		return filledUpData;
	} catch (error) {
		console.error("Error processing Excel data:", error);
		return [];
	}
};

const useExcelData = (topicKey) => {
	const [excelData, setExcelData] = useState(null);
	const dataCache = useRef({});

	const handleDownload = () => {
		if (!dataCache.current[topicKey]) return;
		const fileUrl = getExcelPath(topicKey); // 文件在 /public 目錄下
		const link = document.createElement("a");
		link.href = fileUrl;
		link.download =
			topicKeyExcelFileNameMapping[topicKey] || `${topicKey}.xlsx`; // 下載時的文件名稱
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	useEffect(() => {
		if (dataCache.current[topicKey]) {
			setExcelData(dataCache.current[topicKey]);
			return;
		}
		const url = getExcelPath(topicKey);

		(async () => {
			try {
				const response = await fetch(url);
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				const file = await response.arrayBuffer();
				const workbook = read(file);

				const data = processExcelData(workbook);
				dataCache.current[topicKey] = data;
				setExcelData(data);
			} catch (error) {
				setExcelData(null);
				// Log the error to the console for debugging purposes
				console.error("Failed to fetch or process Excel file:", error);
			}
		})();
	}, [topicKey]);

	return { excelData, handleDownload };
};

export default useExcelData;
